import { shallowRef } from "vue";
import { defineStore } from "pinia";
import { asyncComputed } from "@vueuse/core";

import { WPSClient } from "../wps/client";

export const useWpsStore = defineStore("wps", () => {
  const wpsClient = shallowRef<WPSClient | null>(null);

  const sessionPath = asyncComputed<string | null>(async () => {
    if (!wpsClient.value) {
      return null;
    }

    const session = await wpsClient.value.session();
    return session?.path || null;
  });

  return {
    setClient(client: WPSClient) {
      wpsClient.value = client;
    },
    client: wpsClient,
    sessionPath,
  };
});
